import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import NoPhotos from '../../../../assets/images/no-photo.svg';
import { selectWebsiteTheme } from '../../../../store/slices/website';
import CLFontIcon from '../../../../components/CLFontIcon';

import {
  Container, List, Image, Button, Counter,
} from './styled';

const Gallery = ({ images }) => {
  const myRef = useRef(null);
  const { t } = useTranslation();

  const { colors } = useSelector(selectWebsiteTheme);

  const [selected, setSelected] = useState(0);
  const isFirst = selected === 0;
  const isLast = selected === images.length - 1;
  const hasPhotos = !!images.length;

  useEffect(() => {
    if (!myRef) {
      return;
    }
    const { current } = myRef;

    current.scrollTo({
      left: current.clientWidth * selected,
      behavior: 'smooth',
    });
  }, [selected]);

  const prev = () => {
    setSelected((index) => (index > 0 ? index - 1 : 0));
  };

  const next = () => {
    const last = images.length - 1;
    setSelected((index) => (index < last ? index + 1 : last));
  };

  return (
    <Container bgColor={colors[2].color}>
      {!isFirst && hasPhotos && (
        <Button position="left" onClick={() => prev()}>
          <CLFontIcon icon="caret-left" />
        </Button>
      )}
      {!isLast && hasPhotos && (
        <Button position="right" onClick={() => next()}>
          <CLFontIcon icon="caret-right" />
        </Button>
      )}

      {hasPhotos && (
        <Counter>
          {selected + 1}
          {' '}
          {t('n_of_max', 'of')}
          {' '}
          {images.length}
        </Counter>
      )}

      <List ref={myRef}>
        {hasPhotos ? images.map((item) => (
          <Image key={item.file_id} url={item.large_url} />
        )) : <Image noPhoto url={NoPhotos} />}
      </List>
    </Container>
  );
};

Gallery.propTypes = {
  images: PropTypes.array.isRequired,
};

export default Gallery;
